module.exports = __webpack_public_path__ + "img/org01.0de6e843.png";